// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"0ed5a15b","47":"743a4d2e","66":"bff05dd9","81":"b6d6cc17","148":"530880be","159":"7ea85594","263":"d5460485","333":"35e58a1f","356":"b037f1a5","412":"4002b934","567":"b98fdd7c","602":"6cb2cb0f","650":"ba03f7b7","694":"6805a630","776":"98f51720","787":"946de56b"}[chunkId] + ".chunk.js";
};